import styled from "styled-components";

export const UserStatusPromocodeInfoStyled = styled.div`
    padding: 16px;
    border-radius: var(--border-radius);
    background-color: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
    
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
